import React, { useEffect, useState, useCallback } from "react";
import {
  Typography,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import ExpandMoreIcon from "../assets/icons/ExpandMoreIcon.png";
import MinusIcon from "../assets/icons/MinusIcons.png";
import uploadIcon from "../assets/icons/uploadIcon.png";
import { fetchBulkCVEs, fetchCVE } from "../actions/epssAction.js";
// import "../firebase.js";
import {
  CenteredTableContainer,
  StyledTable,
  StyledTableHeadCell,
  StyledTableBodyCell,
  ToggleIconButton,
  BulkCustomAccordionDetails,
  BulkCustomTypography,
  BulkCustomAccordionSummary,
  BulkCustomAccordion,
  IconImage,
  BulkUploadInputLabel,
  DownloadLinkLabel,
  UploadButton,
  DownloadLinks,
  BulkScoreContainer,
  ReferencesContainer,
  ReferenceItem,
  ReferenceLink,
  AccordionSummaryValues,
  StyledTableRow,
  SingleCveErrorText,
  BulkCveErrorText,
  NoUnderlineLink,
} from "../assets/styles/bulkCveStyledComponents.js";
import leftArrowIcon from "../assets/icons/leftArrowIcon.png";
import downArrowIcon from "../assets/icons/downArrowIcon.png";
import {
  ButtonGroupStyled,
  CveTitleText,
  FetchButton,
  IconWrapper,
  InputField,
  MainContentBox,
  SingleCveScoreContainer,
  StyledButton,
} from "../assets/styles/singlecveStyledComponent.js";
import HeaderContainer from "./HeaderContainer.js";
import ProductDetailsForm, {
  ScoreDisplayContainer,
  ScoreTitle,
  GaugeContainer,
  ScoreValueDisplay,
  ScoreNumber,
  ScoreMax,
  RiskTier,
} from "./ProductDetailsForm.js";
import VulnerabilityDetails from "./VulnerabilityDetails.js";
import WhatHappensNext from "./WhatHappensNext.js";
import SecurityAdvocate from "./SecurityAdvocate.js";
import DeviceSecurityForAll from "./DeviceSecurityForAll.js";
import HowItWorks from "./HowItWorks.js";
import CybersecurityExperts from "./CybersecurityExperts.js";
import Pricing from "./Pricing.js";
// import firebase from "firebase/compat/app";
import CancelIcon from "@mui/icons-material/Cancel";
// import { getAuth, signInWithCustomToken } from "firebase/auth";
import CSV_template from "../assets/csv/CSV_template.csv";
import Excel_template from "../assets/csv/Excel_template.xlsx";
// import FirebaseUIComponent from "./FirebaseUIComponent.js";
// import Cookies from "js-cookie";
import { POST_API } from "../utils/api.js";
import { API_DOMAIN } from "../utils/domain.js";
import { useLocation, useNavigate } from "react-router-dom";
import { BetaText, HeaderBoxNew } from "../assets/styles/MainComponent.js";
import {
  TextContainer,
  TitleText,
  SubTitle,
} from "../assets/styles/MainComponent.js";


const MainComponent = () => {
  const [state, setState] = useState({
    tabValue: 2,
    cve_id: "",
    singleCveResponse: null,
    bulkCveResponse: null,
    expanded: false,
    expandedIndex: null,
    error: "",
    singleCveExpandedIndex: [0, 1, 2, 3, 4, 5, 6, 7, 8],
    showScoreContainer: false,
    isBulkFetching: false,
    isSingleFetching: false,
    openSections: {},
    expandedAccordions: {},
    selectedFile: null,
    singleCveError: "",
    bulkCveError: "",
    isUserLoggedIn: false,
    vendor: "",
    product: "",
    version: "",
    riskScore: null,
  });
  const location = useLocation();
  const navigate = useNavigate();

  const handleRiskScoreCalculated = useCallback((scoreData) => {
    setState((prevState) => ({
      ...prevState,
      riskScore: scoreData,
    }));
  }, []);

  // Scroll to score display when risk score is calculated
  useEffect(() => {
    if (state.riskScore) {
      // Wait for the DOM to update, then scroll
      setTimeout(() => {
        const scoreElement = document.querySelector('#risk-score-display');
        if (scoreElement) {
          scoreElement.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
          });
        }
      }, 100);
    }
  }, [state.riskScore]);

  // useEffect(() => {
  //   if (state.cve_id.trim() !== "") {
  //     setState((prevState) => ({
  //       ...prevState,
  //       singleCveError: "",
  //       singleCveResponse: null,
  //       expandedIndex: null,
  //       expandedAccordions: {},
  //     }));
  //   }
  // }, [state.cve_id]);

  useEffect(() => {
    // Always navigate to product-details on load
    if (!location.search || location.search === "") {
      navigate("/?tab=product-details", { replace: true });
    }
  }, []);

  return (
    <>
      <HeaderBoxNew
        showScoreContainer={state.showScoreContainer}>
        <TextContainer>
          {/* <TitleText>Risk Calculator</TitleText> */}
          <TitleText>Your Connected Devices Are More Vulnerable Than You Think
            <BetaText></BetaText>
          </TitleText>

          <SubTitle>
            Get real-time alerts about security risks in your smart home and office devices - before hackers exploit them.
            <span className="lineBreak">
            </span>
          </SubTitle>

        </TextContainer>
        {/* Tab buttons hidden for Product Details only view */}


        <MainContentBox>

          {/* Product Details Form - New Tab */}
          <ProductDetailsForm onRiskScoreCalculated={handleRiskScoreCalculated} />
        </MainContentBox>

      </HeaderBoxNew>

      {/* Risk Score Display - Below MainContentBox */}
      {state.riskScore && (
        <CenteredTableContainer id="risk-score-display" sx={{ marginTop: "3rem !important" }}>
          <ScoreDisplayContainer active={!!state.riskScore}>
            <ScoreTitle>Product Security Risk Score</ScoreTitle>

            <GaugeContainer>
              <svg className="gauge-svg" viewBox="0 0 300 180" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%', filter: 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.08))' }}>
                <defs>
                  <linearGradient id="gaugeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" style={{ stopColor: '#10b981', stopOpacity: 1 }} />
                    <stop offset="25%" style={{ stopColor: '#34d399', stopOpacity: 1 }} />
                    <stop offset="50%" style={{ stopColor: '#fbbf24', stopOpacity: 1 }} />
                    <stop offset="75%" style={{ stopColor: '#fb923c', stopOpacity: 1 }} />
                    <stop offset="100%" style={{ stopColor: '#ef4444', stopOpacity: 1 }} />
                  </linearGradient>

                  <filter id="glow">
                    <feGaussianBlur stdDeviation="2" result="coloredBlur" />
                    <feMerge>
                      <feMergeNode in="coloredBlur" />
                      <feMergeNode in="SourceGraphic" />
                    </feMerge>
                  </filter>
                </defs>

                {/* Gray Dashed Background Arc */}
                <path
                  d="M 40 150 A 110 110 0 0 1 260 150"
                  fill="none"
                  stroke="#d1d5db"
                  strokeWidth="20"
                  strokeLinecap="round"
                  strokeDasharray="8 6"
                />

                {/* Colored Progress Arc */}
                <path
                  d="M 40 150 A 110 110 0 0 1 260 150"
                  fill="none"
                  stroke="url(#gaugeGradient)"
                  strokeWidth="20"
                  strokeLinecap="round"
                  strokeDasharray={`${(state.riskScore.riskScoreValue / 100) * (Math.PI * 110)} ${Math.PI * 110}`}
                />

                {/* Pointer Dot */}
                <circle
                  cx={150 + 110 * Math.cos((180 - state.riskScore.riskScoreValue * 1.8) * Math.PI / 180)}
                  cy={150 - 110 * Math.sin((180 - state.riskScore.riskScoreValue * 1.8) * Math.PI / 180)}
                  r="11"
                  fill="#ef4444"
                  stroke="white"
                  strokeWidth="4"
                  filter="url(#glow)"
                />
              </svg>

              <ScoreValueDisplay>
                <RiskTier riskLevel={state.riskScore.riskTier.level}>
                  {state.riskScore.riskTier.text}
                </RiskTier>
              </ScoreValueDisplay>
            </GaugeContainer>


            {/* Vulnerability Details Section */}
            <VulnerabilityDetails
              riskScore={state.riskScore}
              vendorData={state.riskScore?.vendor}
              productData={state.riskScore?.product}
            />
          </ScoreDisplayContainer>
        </CenteredTableContainer>
      )}

      {/* What Happens Next Section - Always visible */}
      <WhatHappensNext />

      {/* Security Advocate Section - Always visible */}
      <SecurityAdvocate />

      {/* Device Security For All Section - Always visible */}
      <DeviceSecurityForAll />

      {/* How It Works Section - Always visible */}
      <HowItWorks />

      {/* Cybersecurity Experts Section - Always visible */}
      <CybersecurityExperts />

      {/* Pricing Section - Always visible */}
      <Pricing />

    </>
  );
};

export default MainComponent;
